/**
 * The application's provider tree.
 *
 * It is short on purpose: theme settings, navigation state and modals live in
 * Zustand stores (`src/stores/`), so nothing has to be wrapped for them to
 * work. What remains here is what genuinely needs a provider — the query
 * client, the tRPC client and the MUI/Emotion theme.
 */
import type { ReactNode } from 'react'

import { QueryClientProvider } from '@tanstack/react-query'

import type { Direction } from '@core/types'

import ThemeProvider from '@components/theme'

import AppReactToastify from '@/lib/styles/app-react-toastify'
import { TRPCProvider, queryClient, trpcClient } from '@/lib/trpc'
import { systemMode } from '@/stores/settings'

type Props = {
  children: ReactNode
  direction?: Direction
}

const Providers = ({ children, direction = 'ltr' }: Props) => (
  <QueryClientProvider client={queryClient}>
    <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
      <ThemeProvider direction={direction} systemMode={systemMode()}>
        {children}
        <AppReactToastify direction={direction} />
      </ThemeProvider>
    </TRPCProvider>
  </QueryClientProvider>
)

export default Providers
